import { useMutation } from "@tanstack/react-query";
import { apiClient } from "~/services/api.service";
import { endpointsPublic } from "~/services/endpoint";

// Định nghĩa kiểu dữ liệu cho form
interface RegisterForm {
  name: string;
  email: string;
  system: string;
  phone: string;
  packagePrice: string;
}

export const useCreateRegisterMutation = () => {
  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: (formData: RegisterForm) => {
      return apiClient.post(endpointsPublic.register_package, {data: formData});
    },
    onSuccess: () => { console.log('Gửi thành công!'); },
    onError: (error) => { console.error('Có lỗi:', error); },
  });

  return {
    createRegister: mutateAsync,
    isLoading: isPending,
    error,
  };
};